module.exports = __webpack_public_path__ + "img/logoGalaposPdf.22db0dba.png";